import { render, staticRenderFns } from "./coachPassage.vue?vue&type=template&id=7a5effb8&scoped=true&"
import script from "./coachPassage.vue?vue&type=script&lang=js&"
export * from "./coachPassage.vue?vue&type=script&lang=js&"
import style0 from "./coachPassage.vue?vue&type=style&index=0&id=7a5effb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5effb8",
  null
  
)

export default component.exports